import type { ReceiptTemplate } from '../schema';

export const chromeHeartsTemplate: ReceiptTemplate = {
  id: 'chrome-hearts',
  name: 'Chrome Hearts Receipt',
  brand: 'CHROME HEARTS',
  description: 'Chrome Hearts luxury jewelry and accessories receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'ch-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/chrome-hearts.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 18,
        addressLines: [
          '8920 MELROSE AVE',
          'WEST HOLLYWOOD, CA 90069',
          '(310) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ch-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'trans', label: 'Trans #:', value: '28451' },
          { id: 'assoc', label: 'Associate:', value: 'MIKE W.' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '3:22 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ch-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'CH PLUS RING SILVER', quantity: '1', price: '1250.00', sku: '847291' },
          { id: '2', name: 'PAPER CHAIN NECKLACE', quantity: '1', price: '2850.00', sku: '847292' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ch-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '4100.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '369.00', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '4469.00', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'ch-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'AMEX ****7829',
        fields: [
          { id: 'auth', label: 'Auth:', value: '847291' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'ch-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'ALL SALES FINAL\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

